<template>
  <div>
    <vxe-toolbar id="toolbarId" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <!-- <el-button @click="funcFilter">查询</el-button> -->
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="600"
      :data="tableData"
      sort-config.remote
      export-config
      @sort-change="sortList"
    >
      <vxe-table-column field="collectionStartTime" title="代收协议开始时间" min-width="100" />
      <vxe-table-column field="collectionEndTime" title="代收协议终止时间" min-width="100" />
      <vxe-table-column title="操作" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="查看协议" placement="top">
            <vxe-button type="text" @click="showCollectionAgreementModel(scope.row.code)">
              查看协议
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal v-model="collectionAgreementFlag" title="代收协议" width="800" height="800" resize>
      <collectionAgreement ref="collectionAgreementRef" action-path="log" @hideModel="hideCollectionAgreementModel" />
    </vxe-modal>
  </div>
</template>
<script>
  import collectionAgreement from "./collectionAgreement.vue";
  import request from '@/utils/request'

  export default {
    name: 'AcceptVehicleCollectionLogList',
    components: {
      collectionAgreement
    },
    data() {
      return {
        message: '',
        loading: false,
        tableData: [],
        collectionAgreementFlag: false,
        listQuery: {
          code: '',
          branchCode: '',
          acceptCode: '',
          teamCode: '',
          driverCode: '',
          collectionStartTime: '',
          collectionEndTime: '',
          pageNum: 1,
          pageSize: 20,
          sortField: '',
          sortType: '',
          total: 0
        },
		Pagingconf: []
      }
    },
    created() {
      //this.findList()
    },
    methods: {
    // 查询
      hideCollectionAgreementModel() {
        this.collectionAgreementFlag = false;
      },
      showCollectionAgreementModel(code) {
        this.collectionAgreementFlag = true;
        this.$refs.collectionAgreementRef.init(code);
      },
      init(code){
        if(code){
          this.listQuery.acceptCode = code;
          this.initQuery = JSON.stringify(this.listQuery)
        }
        this.findList();
      },
      findList() {
        this.loading = true
        return new Promise(resolve => {
          request({
            url: '/ntocc-tms-api/acceptVehicleCollectionLog',
            method: 'get',
            params: this.listQuery
          }).then(response => {
            this.tableData = response.data.records
            this.listQuery.total = response.data.total
			response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
            this.loading = false
            resolve();
          })
        })
      },
      // 底部颜色设置
      footerCellClassName({$rowIndex, column, columnIndex}) {
        if (columnIndex === 0) {
          if ($rowIndex === 0) {
            return 'col-blue'
          } else {
            return 'col-red'
          }
        }
      },
      // 设置底部合计
      footerMethod({columns, data}) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计'
            }
            if (['pageviews', 'forecast'].includes(column.property)) {
              return  this.$XEUtils.sum(data, column.property)
            }
            return null
          })
        ]
      }
    }
  }
</script>
